var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    { attrs: { name: "my-teacher-modal" }, on: { closed: _vm.closeModal } },
    [
      _c(
        "div",
        { staticClass: "modal-container" },
        [
          _c(
            "div",
            { staticClass: "modal-header" },
            [
              _c("page-title", { staticClass: "modal-title" }, [
                _vm._v("My Teachers"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "modal-description" }, [
                _vm._v(
                  "Your parents and teachers can help you get the most out of ReadTheory. "
                ),
                _c(
                  "span",
                  {
                    staticClass: "invite-learn-more",
                    on: {
                      click: function ($event) {
                        _vm.learnMoreVisible = !_vm.learnMoreVisible
                      },
                    },
                  },
                  [
                    _vm._v("Really, How? "),
                    _c("rt-picture", {
                      attrs: { src: "/assets/app/quiz/icon-dropdown.svg" },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "VueSlideToggle",
                {
                  staticClass: "learnmore-container",
                  attrs: {
                    open: _vm.learnMoreVisible,
                    tag: "div",
                    duration: 500,
                  },
                },
                [
                  _c("div", { staticClass: "subtitle" }, [
                    _vm._v(
                      "Parents and teachers can do these awesome things..."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "learnmore-list" }, [
                    _c("li", [_vm._v("Track your reading progress")]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v("Analyze your mastery of Common Core Standards"),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "Review your recent quizzes with you, side-by-side"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [_vm._v("Include you in class progress reports")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("Grade your written responses")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("Reset your password if you forget it")]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _vm.mustProviderName
              ? _c("div", { staticClass: "update-container" }, [
                  _c("p", { staticClass: "modal-description" }, [
                    _vm._v(
                      "Looks like we need a little more information to get you started. Please provide your name below, so that your teachers can identify you. (Remember, you can always update this information in your "
                    ),
                    _c("a", { attrs: { href: "/user/manage" } }, [
                      _vm._v("account settings"),
                    ]),
                    _vm._v(")."),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "edit-wrapper" },
                    [
                      _c("rt-input", {
                        ref: "firstName",
                        staticClass: "modal-input",
                        attrs: {
                          placeholder: `Real First Name ${
                            _vm.coppaStudent ? "Initial" : ""
                          }`,
                          maxLength: _vm.coppaStudent ? 1 : 50,
                        },
                        model: {
                          value: _vm.firstName,
                          callback: function ($$v) {
                            _vm.firstName = $$v
                          },
                          expression: "firstName",
                        },
                      }),
                      _vm._v(" "),
                      _c("rt-input", {
                        ref: "lastName",
                        staticClass: "modal-input",
                        attrs: { placeholder: "Real Last Name" },
                        model: {
                          value: _vm.lastName,
                          callback: function ($$v) {
                            _vm.lastName = $$v
                          },
                          expression: "lastName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "submit-wrapper" },
                    [
                      _c(
                        "primary-button",
                        { on: { click: _vm.updateInformation } },
                        [
                          _vm._v(
                            "\n                Update Information\n                "
                          ),
                          _vm.loading
                            ? _c("div", { staticClass: "loading-spinner" })
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _c("div", { staticClass: "invite-container" }, [
                  _c("h2", { staticClass: "sub-title" }, [
                    _vm._v("Enter your Class code or Teacher’s email "),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "modal-description" }, [
                    _vm._v(
                      "Input a class code given by your teacher to join the class or invite teacher to track your progress by entering their email in the space below."
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-wrapper" },
                    [
                      _c("rt-input", {
                        ref: "inviteValue",
                        staticClass: "modal-input",
                        attrs: { placeholder: "Class code or Teacher’s email" },
                        model: {
                          value: _vm.inviteValue,
                          callback: function ($$v) {
                            _vm.inviteValue = $$v
                          },
                          expression: "inviteValue",
                        },
                      }),
                      _vm._v(" "),
                      _vm.submitError
                        ? _c(
                            "div",
                            { staticClass: "error-wrapper" },
                            [
                              _c("rt-picture", {
                                attrs: {
                                  src: "/assets/app/class/icon-warning-white.svg",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "error-info" }, [
                                _vm._v(_vm._s(_vm.submitError)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "primary-button",
                                {
                                  staticClass: "btn-normal btn-dismiss",
                                  on: {
                                    click: function ($event) {
                                      _vm.submitError = null
                                    },
                                  },
                                },
                                [
                                  _c("rt-picture", {
                                    attrs: {
                                      src: "/assets/app/class/icon-closed.svg",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.submitSuccessInfo && _vm.submitSuccessInfo.joined
                        ? _c(
                            "div",
                            { staticClass: "success-info-wrapper" },
                            [
                              _c("avatar", {
                                attrs: {
                                  username: _vm.submitSuccessInfo.className,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "success-content" }, [
                                _c(
                                  "p",
                                  { staticClass: "success-content-message" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.submitSuccessInfo.message)
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", {
                                  staticClass: "success-content-description",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.submitSuccessInfo.description
                                    ),
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "primary-button",
                                {
                                  staticClass: "btn-normal btn-dismiss",
                                  on: {
                                    click: function ($event) {
                                      _vm.submitSuccessInfo = null
                                    },
                                  },
                                },
                                [
                                  _c("rt-picture", {
                                    attrs: {
                                      src: "/assets/app/class/icon-closed.svg",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "submit-wrapper" },
                    [
                      _c("primary-button", { on: { click: _vm.sendRequest } }, [
                        _vm._v("\n              Send request\n              "),
                        _vm.loading
                          ? _c("div", { staticClass: "loading-spinner" })
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-separator" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "teachers-wrapper",
                      class: { empty: _vm.teachers.length === 0 },
                    },
                    [
                      _c("h2", { staticClass: "sub-title" }, [
                        _vm._v("Current teachers"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "modal-description" }, [
                        _vm._v(
                          "These teachers are currently tracking your progress"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "teachers-list" },
                        _vm._l(_vm.teachers, function (teacher, idx) {
                          return _c(
                            "li",
                            { key: idx, staticClass: "teacher-item" },
                            [
                              _c("div", { staticClass: "teacher-info" }, [
                                _c("p", { staticClass: "teacher-name" }, [
                                  _vm._v(_vm._s(teacher.name)),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "teacher-email" }, [
                                  _vm._v(_vm._s(teacher.email)),
                                ]),
                              ]),
                              _vm._v(" "),
                              teacher.state === "NoReply"
                                ? _c(
                                    "div",
                                    { staticClass: "invite-status" },
                                    [
                                      _c("rt-picture", {
                                        attrs: {
                                          src: "/assets/app/quiz/icon-pending.svg",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { staticClass: "invite-status-text" },
                                        [_vm._v("PENDING")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !teacher.dismissed &&
                              teacher.replyDate &&
                              _vm.lastViewDatetime &&
                              teacher.replyDate > _vm.lastViewDatetime
                                ? _c(
                                    "div",
                                    { staticClass: "success-info-wrapper" },
                                    [
                                      _c("avatar", {
                                        attrs: { username: teacher.name },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "success-content" },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "success-content-message",
                                            },
                                            [
                                              _vm._v(
                                                "Teacher accepted your request"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "success-content-description",
                                            },
                                            [
                                              _vm._v("\n\t\t\t\t\t\tNow "),
                                              _c("b", [
                                                _vm._v(_vm._s(teacher.name)),
                                              ]),
                                              _vm._v(
                                                " is tracking your progress\n\t\t\t\t\t"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "primary-button",
                                        {
                                          staticClass: "btn-normal btn-dismiss",
                                          on: {
                                            click: function ($event) {
                                              return _vm.dismissTeacherInfo(
                                                teacher
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("rt-picture", {
                                            attrs: {
                                              src: "/assets/app/class/icon-closed.svg",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("loading", {
                        attrs: {
                          active: _vm.teacherLoading,
                          width: 40,
                          height: 40,
                          color: "#000",
                          "background-color": "transparent",
                          "is-full-page": false,
                        },
                        on: {
                          "update:active": function ($event) {
                            _vm.teacherLoading = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
          ]),
          _vm._v(" "),
          _c(
            "primary-button",
            {
              staticClass: "btn-normal btn-close",
              on: { click: _vm.closeModal },
            },
            [
              _c("rt-picture", {
                attrs: { src: "/assets/app/quiz/icon-close-blue.svg" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }